import axios from "axios";

const API = `${process.env.REACT_APP_API_URL}/user`;

const authHeader = () => ({
  "x-user-token": localStorage.getItem("userToken") || ""
});

export const googleSignIn = async (credential) => {
  const res = await axios.post(`${API}/google`, { credential });
  return res.data;
};

export const getProfile = async () => {
  const res = await axios.get(`${API}/me`, { headers: authHeader() });
  return res.data;
};
